module.exports = __webpack_public_path__ + "entry-logged-out-48909c19/discovered-background-small-c1e90efa33868037519425a897368b0b.svg";